<template>
  <div
    key="new_status"
    :class="{
      'drawer__add-item': !isBeingEdited,
      'drawer__list-item is-editing': isBeingEdited,
      'is-loading': isLoading
    }"
    @click="!isBeingEdited && startEditing()"
  >
    <transition name="switch" appear mode="out-in" @after-enter="focusInput()">
      <!-- Add Button -->
      <div
        v-if="!isBeingEdited"
        key="add_button"
        class="flex items-center gap-2 w-full"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        <span>{{ $t("Add new status") }}</span>
      </div>

      <!-- Edit Form -->
      <div class="drawer__form w-full" key="form" v-else>
        <div class="drawer__form-row">
          <input
            type="text"
            class="input flex-1"
            v-model="newName"
            @keydown.enter.prevent="handleSave()"
            @keydown.esc.prevent="handleClose()"
            :placeholder="$t('Status name')"
            ref="input"
          />

          <swatch-color-picker
            v-model="newColor"
            dropdown-position="right"
          />
        </div>

        <div v-if="error" class="text-sm text-red-600 mt-1">
          {{ error }}
        </div>

        <div class="drawer__form-actions justify-end">
          <button
            type="button"
            class="text-sm text-neutral-600 hover:text-neutral-800 font-medium"
            @click.stop="handleClose()"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            type="button"
            class="btn-main text-sm px-3 py-1.5"
            @click.stop="handleSave()"
          >
            {{ $t('Save') }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SwatchColorPicker from "./swatch-color-picker.vue";

export default {
  props: ["project-id", "status-name"],

  data: function() {
    return {
      isBeingEdited: false,
      isLoading: false,
      newName: "",
      newColor: "#2D80FA",
      error: ""
    };
  },

  components: {
    SwatchColorPicker
  },

  methods: {
    startEditing() {
      this.isBeingEdited = true;
    },

    focusInput() {
      if (this.isBeingEdited) {
        this.$nextTick(() => {
          this.$refs.input && this.$refs.input.focus();
        });
      }
    },

    handleClose() {
      this.isBeingEdited = false;
      this.newName = "";
      this.newColor = "#2D80FA";
      this.error = "";
    },

    handleSave() {
      this.createNewStatus();
    },

    createNewStatus() {
      if (!this.newName || this.newName === this.statusName.not_set) {
        this.error = "Status name is required";
        return;
      }

      this.isLoading = true;
      this.error = "";

      let params = new FormData();
      params.append("label[name]", this.newName);
      params.append("label[color]", this.newColor);
      params.append("label[project_id]", this.projectId);
      params.append("label[hide_roadmap]", false);
      params.append("label[hide_boards]", false);

      Rails.ajax({
        url: "/statuses",
        type: "POST",
        data: params,
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          if (data.error) {
            this.error = data.error;
          } else {
            this.$emit("newLabel", data);
            this.handleClose();
          }
          this.isLoading = false;
        },
        error: (data, status) => {
          console.log(data);
          this.isLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.switch-enter,
.switch-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.switch-enter-to,
.switch-leave {
  opacity: 1;
  transform: translateY(0);
}

.switch-enter-active,
.switch-leave-active {
  transition: opacity 150ms ease, transform 150ms ease;
}
</style>
